<template>
  <v-dialog persistent v-model="dialogVisible" width="35rem">
    <v-card>
      <v-card-title class="primary--text">End Class</v-card-title>
      <v-form ref="form" v-model="endClassValidation.valid">
        <v-container>
          <v-card-title v-if="model == NON_FRANCHISE_MODEL">
            Please select the notes you want to release
          </v-card-title>
          <v-row class="ma-1" v-if="model == NON_FRANCHISE_MODEL">
            <v-col>
              <v-select
                v-model="localCourseCoverage.chapterNo"
                :items="chapterList"
                label="Chapter Name"
                required
                outlined
                dense
                item-text="chapterName"
                item-value="chapterNo"
                @change="fetchLessons(localCourseCoverage.chapterNo)"
                :rules="endClassValidation.nameRules"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="localCourseCoverage.lessonNo"
                :items="lessons"
                label="Lesson Name"
                outlined
                dense
                item-text="lessonName"
                item-value="lessonNo"
                :required="localCourseCoverage.chapterNo > 0"
                :disabled="localCourseCoverage.chapterNo <= 0"
                :rules="lessonRules"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-card-title
            >Can you give us some feedback of the class?</v-card-title
          >
          <v-row class="ma-1">
            <v-col>
              <v-text-field
                v-model="localFeedback"
                label="Feedback"
                :rules="endClassValidation.feedbackRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeDialog()">Cancel</v-btn>
            <v-btn color="primary" text @click="confirmEndClass()"
              >End Class</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { NON_FRANCHISE_MODEL } from "@/common/constants";

export default {
  name: "ClassEndDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => ({}),
    },
    topicCovered: {
      type: [Map, Object],
      default: () => new Map(),
    },
    editedClassOps: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      lessons: [],
      localCourseCoverage: {},
      localFeedback: "",
      selectedChapterName: "",
      selectedLessonName: "",
      endClassValidation: {
        valid: false,
        nameRules: [(v) => !!v || v === 0 || "This is required"],
        feedbackRules: [
          (v) => !!v || "Feedback is required",
          (v) =>
            (v && v.length >= 15) || "Feedback must be at least 15 characters",
        ],
      },
      NON_FRANCHISE_MODEL: NON_FRANCHISE_MODEL,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    chapterList() {
      const defaults = [
        { chapterName: "Previous Chapter", chapterNo: -1 },
        { chapterName: "No Chapter", chapterNo: 0 },
      ];
      return this.course.chapters
        ? [...defaults, ...this.course.chapters]
        : defaults;
    },
    lessonRules() {
      return this.localCourseCoverage.chapterNo > 0
        ? this.endClassValidation.nameRules
        : [];
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    fetchLessons(chapterNo) {
      this.lessons = [];
      if (chapterNo <= 0) return;

      let Chapter = this.course.chapters?.filter((chpt) => {
        return chpt.chapterNo == chapterNo;
      });
      if (Chapter && Chapter[0] && Chapter[0].lessons) {
        this.lessons = Chapter[0].lessons;
        const coveredLessons =
          this.topicCovered instanceof Map
            ? this.topicCovered.has(Number(chapterNo))
              ? this.topicCovered.get(Number(chapterNo))
              : null
            : this.topicCovered[Number(chapterNo)];

        if (coveredLessons) {
          this.lessons = this.lessons.filter((lesson) => {
            return !coveredLessons.includes(lesson.lessonNo);
          });
        }
        this.selectedChapterName = Chapter[0].chapterName;
      }
      if (this.localCourseCoverage.lessonNo) {
        let lessons = this.lessons.filter((lesson) => {
          return lesson.lessonNo == this.localCourseCoverage.lessonNo;
        });
        if (lessons && lessons[0]) {
          this.selectedLessonName = lessons[0].lessonName;
        }
      }
    },
    closeDialog() {
      this.resetForm();
      this.$emit("input", false);
    },
    resetForm() {
      this.localCourseCoverage = {};
      this.localFeedback = "";
      this.lessons = [];
      this.selectedChapterName = "";
      this.selectedLessonName = "";
      this.endClassValidation.valid = false;
    },
    confirmEndClass() {
      this.$refs.form.validate();
      if (this.endClassValidation.valid) {
        const { chapterNo, lessonNo } = this.localCourseCoverage;
        const hasCourseCoverage =
          (chapterNo > 0 && lessonNo) || chapterNo === 0 || chapterNo === -1;

        this.$emit("end-class", {
          editedClassOps: this.editedClassOps,
          feedback: this.localFeedback,
          courseCoverage: hasCourseCoverage ? this.localCourseCoverage : null,
          selectedChapterName: this.selectedChapterName,
          selectedLessonName: this.selectedLessonName,
        });
      }
    },
  },
};
</script>
